import api from './api';
import { SolutionContainer } from '../types';

class SolutionContainerService {
  async getContainers(parentId?: number | null): Promise<SolutionContainer[]> {
    const params = parentId !== undefined ? { parent: parentId } : {};
    const response = await api.get('/solution-containers/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<SolutionContainer> {
    const response = await api.get(`/solution-containers/${id}/`);
    return response.data;
  }

  async createContainer(data: Partial<SolutionContainer>): Promise<SolutionContainer> {
    const response = await api.post('/solution-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<SolutionContainer>): Promise<SolutionContainer> {
    const response = await api.patch(`/solution-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/solution-containers/${id}/`);
  }

  async reorderContainers(items: Array<{ id: number; order: number; parent?: number | null }>): Promise<void> {
    await api.post('/solution-containers/reorder/', { items });
  }

  async getContents(containerId: number): Promise<{containers: SolutionContainer[], solutions: any[]}> {
    const response = await api.get(`/solution-containers/${containerId}/contents/`);
    return response.data;
  }
}

const solutionContainerService = new SolutionContainerService();
export default solutionContainerService;
